import {DropdownParams} from "./DropdownParams";

/**
 * The product form renders a dropdown per variation, each preloading the same option lists
 * (suppliers, customer groups, ...). Identical preloads inside this window share one request.
 */
const preloadCache = new Map();
const PRELOAD_CACHE_MS = 30000;

export class Dropdowns {

    /**
     * Fetches a dropdown's options, sharing identical preload requests made from the product form.
     */
    static cachedGet($element, src, params) {
        if ($element.closest('#productsForm').length === 0 || params.query !== '') {
            return axios.get(src, {params: params});
        }

        const key = src + JSON.stringify(params),
            hit = preloadCache.get(key);

        if (hit !== undefined && Date.now() - hit.at < PRELOAD_CACHE_MS) {
            return hit.request;
        }

        const request = axios.get(src, {params: params});

        request.catch(() => preloadCache.delete(key));
        preloadCache.set(key, {at: Date.now(), request: request});

        return request;
    }

    static clearPreloadCache() {
        preloadCache.clear();
    }

    static selectize(selector) {

        if($(selector).is('select')) {
            Dropdowns.initSelectizeHandler($(selector));
        }

        $(selector).find('select:not(.selectize-template)').each(function () {
            Dropdowns.initSelectizeHandler($(this));
        })
    }

    static initSelectizeHandler($element) {
        if($.fn.selectize === undefined){
            selectize = require('selectize');

            selectize.define('preserve_search', function (options) {
                var self = this;

                options.text = options.text || function (option) {
                    return option[this.settings.labelField];
                };

                this.onBlur = (function (e) {
                    var original = self.onBlur;

                    return function (e) {
                        // Capture the current input value
                        var $input = this.$control_input;
                        var inputValue = $input.val();

                        // Do the default actions
                        original.apply(this, [e]);

                        // Set the value back
                        this.setTextboxValue(inputValue);
                    };
                })();

                this.onOptionSelect = (function (e) {
                    var original = self.onOptionSelect;

                    return function (e) {
                        // Capture the current input value
                        var $input = this.$control_input;
                        var inputValue = $input.val();

                        original.apply(this, [e]);
                        this.setTextboxValue(inputValue);
                        this.refreshOptions();
                        if (this.currentResults.items.length <= 0) {
                            this.setTextboxValue('');
                            this.refreshOptions();
                        }
                    };
                })();
            });
        }


        let params = {},
            selectize = undefined,
            src = "",
            selected = "";

        if((src = ($element.attr('data-src') ?? $element.data('src'))) !== undefined) {

            params = Object.assign(params, {
                // plugins: ['preserve_search'],
                preload: true,
                valueField: $element.data('src-value') ?? 'id',
                labelField: $element.data('src-label') ?? 'name',
                searchField: $element.data('src-label') ?? 'name',
                load: function(query, callback) {
                    Dropdowns.selectizeAxiosLoad($element, src, selectize, callback, query);
                },
            });
        }
        else {
            /** If src not set it will allow a selected option */
            if ((selected = $element.data('selected')) !== undefined){
                $element.val(selected);
            }
        }

        //Loading the specific parameters for this dropdown
        if($element.data('init') !== undefined)
            params = Object.assign(params, DropdownParams[$element.data('init')](params, $element));


        selectize = $element.selectize(params)[0].selectize;
    }

    static selectizeAxiosLoad($element, src, selectize, callback, query, additionalParams = {}) {
        if(query == undefined)
            query = {};

        let params = Object.assign({
            query: query,
            selectize: true
        }, additionalParams)

        if($element.data('selected') != undefined && $element.data('selected') != '') {
            params.ids = [$element.data('selected')]
        }

        Dropdowns.cachedGet($element, src, params).then(response => {

            // Each dropdown needs its own copy: selectize keeps and mutates the option objects it is given
            const data = JSON.parse(JSON.stringify(response.data));

            callback(data);

            if($element.data('selected') !== undefined) {
                if(!isNaN($element.data('selected'))) {
                    selectize.addItem($element.data('selected'), !$element.is('[data-select-not-silent]'));
                } else if(Array.isArray($element.data('selected'))) {
                    $element.data('selected').forEach(item => {
                        selectize.addItem(item, !$element.is('[data-select-not-silent]'));
                    })
                } else {
                    selectize.addItem($element.data('selected'), !$element.is('[data-select-not-silent]'));
                }
            } else if ($element.is('[data-select-first]')){

                //This is needed for stock fulfillment on order items
                selectize.refreshItems();

                if(data[0] !== undefined)
                    selectize.addItem(data[0].id)
                else
                    selectize.addItem(selectize.options[Object.keys(selectize.options)[0]].id)


            }


            $element.trigger('selectize-loaded');
        })
    }
}
